import { EMobileActiveSideTypes } from '../../actions/mobileSide';
import { TAppState } from '../../types/appState';
import { TReduxActions } from '../../types/redux/actions';

export function mobileSideReducer(state: TAppState, action: TReduxActions): TAppState {
  switch (action.type) {
    case EMobileActiveSideTypes.SetActive:
      return {
        ...state,
        mobileSide: action.payload,
      };

    default:
      return state;
  }
}
